import { render, staticRenderFns } from "./JyReportDetail.vue?vue&type=template&id=20cb7936&"
import script from "./JyReportDetail.vue?vue&type=script&lang=js&"
export * from "./JyReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./JyReportDetail.vue?vue&type=style&index=0&id=20cb7936&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports